import React from "react";

const Dashboard = () => {
  return (
    <div>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
      <p>Dashboard</p>
    </div>
  );
};

export default Dashboard;
